import RecargoUpdate from './RecargoUpdate'
export { RecargoUpdate }
export default RecargoUpdate
